<template>
  <div class="full-height center-flex">
    <div v-if="isEmpty">
      <h2 class="ui center aligned header">
        <i class="circular camera grey icon" />
      </h2>
    </div>
    <div
      v-else
      class="ui card"
    >
      <div class="content">
        <div class="header">
          Camera Details here.
        </div>
        <div class="subheader">
          {{ name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CameraDetail',
  computed: {
    isEmpty: function () {
      return this.$route.params.id === undefined
    },
    name: function () {
      const id = this.$route.params.id
      return id
    },
  },
}
</script>

<style scoped>
  .center-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
